import React from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity } from 'react-native';
import Text from '../text';
import { StylePropType } from '../../../utils/prop-types';
import styles from './button.styles';

function Button({ disabled, inline, size, style, title, transparent, onClick, onPress, className, ...props }) {
  const touchableStyle = [];
  const onClickFunc = onClick || onPress;

  if (!inline && !transparent) {
    touchableStyle.push(styles.block);
    const sizeStyle = styles[size];
    if (sizeStyle) touchableStyle.push(sizeStyle);
  }


  if (disabled) touchableStyle.push(styles.disabled);
  if (style) touchableStyle.push(style);

  const textStyle = [styles.text];
  if (inline) textStyle.push(styles.inline);
  if(transparent) textStyle.push(styles.transparent);


  return (
    <TouchableOpacity {...props} onPress={onClickFunc} disabled={disabled}>
      {!inline &&
        <div className={'button '+ className} size={size}>
          <Text size={size} >{title}</Text>
        </div>
      }
      {inline &&
        <div id={title} className="inline-link">
          <span size={size}>{title}</span>
        </div>
      }
    </TouchableOpacity>
  );
}

Button.propTypes = {
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
  size: Text.propTypes.size,
  style: StylePropType,
  title: PropTypes.string,
};

Button.defaultProps = {
  inline: false,
  size: 'normal',
};

export default Button;
